import {UI} from "../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../PanelPage";
import {iFrameState} from "../../../services/IFrameState";
import {PoweredByBlink} from "../../panel-elements/PoweredByBlink.jsx";
import {styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {LoginFooter, PromptManageAccountButton} from "../../panel-elements/LoginFooter";
import {PanelText} from "../../panel-elements/PanelText.jsx";
import {MakeActionButton} from "../../panel-elements/ActionButton";
import {PaywallPurchaseFlowHandler} from "../../flows/PaywallPurchaseFlowHandler";
import {StyleElement} from "../../../../stem-core/src/ui/StyleElement";
import {PanelCloseButton} from "../../panel-elements/PanelCloseButton.jsx";
import {MerchantLogo} from "../../../common/MerchantLogo";
import {convertToUI, MessageElement} from "../../../widget/ui/MessageElement";
import {PanelLink} from "../../panel-elements/PanelLink.jsx";
import {PanelImage} from "../../panel-elements/PanelImage.jsx";
import {collapseIframe} from "../../../widget/misc/WidgetUtils.js";
import {authService} from "../../../../client/connection/services/AuthService.js";
import {Flow} from "../../flows/Flow.js";


function MakeLoginFooter(label) {
    return (options, children) => {
        if (authService.isAuthenticated()) {
            return null;
        }
        return <LoginFooter {...options} label={label}>{children}</LoginFooter>;
    }
}


class CustomContentPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    container = {
        padding: null,
        width: "100%",
        ...iFrameState.iframeParams.basePanelStyle
    }

    @styleRuleInherit
    content = {
        width: null,
        padding: null
    }
}

@registerStyle(CustomContentPanelStyle)
export class CustomContentPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            hasHeader: false,
        };
    }

    render() {
        const panelClassMap = new Map([
            ...[
                "div", "span", "p", "i", "nav",
                "strong", "em", "br", "b", "hr",
                "ul", "ol", "li", "code", "var",
                "h1", "h2", "h3", "h4", "h5", "h6",
                "input", "label",
                "parsererror", // This is to nicely display errors generated by DOMParser.parseFromString.
            ].map(tag => ([tag, UI.Primitive(tag)])),

            ["If", UI.Primitive("div")], // TODO @cleanup what?

            ["Style", StyleElement],
            ["PanelLink", PanelLink], // TODO Duplicate because of our current rendering engine (the DOM)
            ["Link", PanelLink],
            ["PanelImage", PanelImage],
            ["Text", PanelText],
            ["Logo", MerchantLogo],
            ["MessageElement", MessageElement], // TODO This should be removed and replaced with a better solution

            ["SubscribeButton", MakeActionButton(Flow.subscribe)],
            ["DonateButton", MakeActionButton(Flow.donation)],
            ["GiftSubscriptionButton", MakeActionButton(Flow.giftSubscription)],
            ["NewsletterButton", MakeActionButton(Flow.newsletter)],
            ["PurchaseButton", MakeActionButton(Flow.payment, {label: () => PaywallPurchaseFlowHandler.getActionButtonLabel()})],

            ["AuthButton", MakeActionButton(Flow.auth)],
            // TODO @cleanup deprecate this terrible name
            ["IdentityButton", MakeActionButton(Flow.auth)],

            ["LinkButton", MakeActionButton(null)],

            ["Close", PanelCloseButton],
            ["CloseButton", MakeActionButton(null, {onClick: () => collapseIframe()})],

            ["LoginFooter", MakeLoginFooter()],

            // TODO @cleanup Remove from panels and then from here
            ["SubscribeLoginFooter", MakeLoginFooter("Already a subscriber?")],
            ["DonateLoginFooter", MakeLoginFooter("Already a donor?")],
            ["PurchaseLoginFooter", MakeLoginFooter("Already purchased?")],

            ["PromptInlineUserDashboard", PromptManageAccountButton], // TODO @cleanup remove this from panels
            ["PromptManageAccountButton", PromptManageAccountButton],
            ["PoweredByBlink", PoweredByBlink],
        ]);

        return convertToUI(iFrameState.iframeParams.contentAST, panelClassMap);
    }

    onMount() {
        super.onMount();
        this.attachListener(iFrameState, "customPanelContentUpdate", () => this.redraw());
    }
}
